module.exports = __webpack_public_path__ + "static/media/background.1a63741f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/my-gift/background.jpg
// module id = 508
// module chunks = 1